import React from "react";
import { useContext } from "react";
import { defaultEmailAccount } from "../global";
import fileIcon from "../../images/icons/word.svg";
import AppContext from "../contexts/app-context";

function PapFileLink(props) {
  const { docName } = props;
  const { accountID } = useContext(AppContext);
  const defaultAccount =
  !accountID || accountID.id1 === false || accountID.id1 === "false"
      ? defaultEmailAccount
      : accountID.id1;

  let orderStrings = "";
 

  
  //https://drive.google.com/drive/search?q=title:230.04.23
  const href =
    `https://mail.google.com/mail/u/${defaultAccount}/?q=in:cognex#search/label%3A-agit-tlumacze+` +
    docName?.slice(0,50);
  
  return (
    <a
      className="googleDriveLink"
      title="Plik na mailu"
      target="_new"
      href={href}
    >
      <div>
        <img alt="papLink" src={fileIcon}></img>
     
      </div>
    </a>
  );
}

export default PapFileLink;
/*      https://drive.google.com/drive/u/${defaultEmailAccount}/search?q="` */
